import {useTranslation} from '@/translations/i18n'
import {StyledAccessesValidatorsEmptyStateWrapper} from './style'
import {Text} from '@/components/ui/text/Text'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {ValidatorSearchParams} from '@/features/accesses/types'

export const AccessesValidatorsEmptyState = () => {
    const {t} = useTranslation()
    const {searchParams} = useParsedSearchParams(ValidatorSearchParams)

    const title = !searchParams.consultant ? t('accesses:no_consultant_selected') : t('accesses:no_accesses_title')
    const description = !searchParams.consultant
        ? t('accesses:no_consultant_selected_description')
        : t('accesses:no_validators_accesses_description')
    return (
        <StyledAccessesValidatorsEmptyStateWrapper>
            <Text size="textXl" weight="500" palette="neutral" shade="600">
                {title}
            </Text>
            <Text size="textLg" palette="neutral" shade="500">
                {description}
            </Text>
        </StyledAccessesValidatorsEmptyStateWrapper>
    )
}
